<template>
  <Teleport to="#modals">
    <Modal @close="() => $emit('close')">
      <template #header-all>
        <BackButton :click="() => $emit('close')" type="button">
          Выбор заместителя
        </BackButton>
      </template>
      <template #content>
        <div class="form">
          <div class="form-grid">
            <div class="form-field">
              <label>Замещающий</label>
              <AutocompleteInput
                v-model="proxyField"
                placeholder="Введите имя замещающего"
                @select="onProxySelect"
              />
              <span v-if="errors?.['proxy']" class="error">
                {{ errors['proxy'] }}
              </span>
            </div>

            <div class="form-field">
              <label>Период замещения с</label>
              <input type="date" v-model="dateFromField" />
              <span v-if="errors?.['dateFrom']" class="error">
                {{ errors['dateFrom'] }}
              </span>
            </div>

            <div class="form-field">
              <label> Период замещения по(включительно) </label>
              <input type="date" v-model="dateToField" />
              <span v-if="errors?.['dateTo']" class="error">
                {{ errors['dateTo'] }}
              </span>
            </div>
            <button
              :disabled="isLoading"
              type="button"
              class="btn btn-next btn-wide"
              @click="handleSave"
            >
              <Loader v-if="isLoading" class="loader-btn" />
              <span v-else>{{ user?.id ? 'Обновить' : 'Добавить' }}</span>
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'
import Modal from '@/components/Modal.vue'
import BackButton from '@/components/BackButton.vue'
import Loader from '@/components/Loader.vue'
import AutocompleteInput from '@/components/AutocompleteInput.vue'
import { useForm } from 'vee-validate'
import { object, string, mixed } from 'yup'
import { requiredText } from '@/constants'

const props = defineProps({
  user: {
    type: Object,
  },
})
const emit = defineEmits(['close', 'submit'])
const isLoading = ref(false)
const selectedUser = ref(null)

const onProxySelect = (user) => {
  selectedUser.value = user
  proxyField.value = user
}

const validationSchema = object({
  proxy: mixed().test('is-valid-proxy', requiredText, function (value) {
    return typeof value === 'object'
  }),
  dateFrom: string().required(requiredText),
  dateTo: string().required(requiredText),
})

const { errors, validate, defineField } = useForm({
  validationSchema,
  initialValues: {
    proxy: props.user?.user,
    dateFrom: props.user?.date_from.slice(0, 10),
    dateTo: props.user?.date_to.slice(0, 10),
  },
})

const [proxyField] = defineField('proxy')
const [dateFromField] = defineField('dateFrom')
const [dateToField] = defineField('dateTo')

const handleSave = async () => {
  const { valid } = await validate()

  if (!valid) return

  try {
    isLoading.value = true

    const dateTo = new Date(dateToField.value)

    const proxyData = {
      user_vrio: proxyField.value.id,
      date_from: dateFromField.value
        ? new Date(dateFromField.value).toISOString()
        : undefined,
      date_to: dateToField.value
        ? new Date(
            new Date(dateToField.value).setHours(23, 59, 59, 999)
          ).toISOString()
        : undefined,
    }

    emit('submit', proxyData)
  } catch (error) {
    console.error(error)
  } finally {
    isLoading.value = false
  }
}
</script>

<style lang="scss" scoped></style>
